/**
 * IMPORTANTE: estos testimonios son EJEMPLOS de formato.
 * Reemplázalos por opiniones reales de tus clientes (con su permiso) antes de publicar.
 * Publicar testimonios inventados puede considerarse publicidad engañosa (PROFECO).
 */
export interface Testimonial {
  id: string
  quote: string
  name: string
  role: string
  city: string
  detail: string
}

export const FEATURED_TESTIMONIAL: Testimonial = {
  id: 't-1',
  quote:
    'Pedí 180 piezas de bovedilla de 15 cm para una losa de 340 m². Llegaron completas, sin piezas rotas y el día que quedamos. El colado salió a tiempo y la cuadrilla no tuvo que andar recortando.',
  name: 'Ing. Ricardo M.',
  role: 'Residente de obra',
  city: 'León, Gto.',
  detail: '180 pzas · Bovedilla 15 cm',
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 't-2',
    quote:
      'Lo que más me gustó es que me dieron el precio en el primer mensaje, con todo claro. Sin vueltas y con factura.',
    name: 'Arq. Daniela R.',
    role: 'Despacho de arquitectura',
    city: 'Querétaro, Qro.',
    detail: 'Casetón 60 x 60',
  },
  {
    id: 't-3',
    quote:
      'Les pedí una medida especial de 17 cm y la tuvieron lista. El material viene parejo, bien cortado y con buena densidad.',
    name: 'Jorge L.',
    role: 'Contratista',
    city: 'Celaya, Gto.',
    detail: 'Medida personalizada',
  },
  {
    id: 't-4',
    quote:
      'Surto mi tienda con ellos. Responden rápido por WhatsApp y la entrega sin costo me ayuda a mantener mi margen.',
    name: 'Materiales Hernández',
    role: 'Casa de materiales',
    city: 'Irapuato, Gto.',
    detail: 'Compra recurrente',
  },
]

/** Compromisos de calidad: ajústalos a lo que tu operación puede garantizar */
export const QUALITY_PROMISES = [
  {
    id: 'medida',
    title: 'Medida exacta',
    text: 'Piezas cortadas parejas: 63 x 300 cm reales, sin sorpresas al colocar.',
  },
  {
    id: 'revision',
    title: 'Revisado antes de salir',
    text: 'Cada pedido se cuenta y se revisa en bodega antes de cargarse.',
  },
  {
    id: 'reposicion',
    title: 'Llega completo o lo reponemos',
    text: 'Si una pieza llega dañada, avísanos al recibir y la reponemos.',
  },
  {
    id: 'factura',
    title: 'Compra formal',
    text: 'Facturamos y te damos cotización por escrito.',
  },
]
